import React, { useState } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    TextField,
    Typography
} from '@material-ui/core';

function DialogoEditar(props) {
    const theme = props.theme;
    const open = props.open;
    const setOpen = props.setOpen;
    const editEvento = props.editEvento;
    const [horas, setHoras] = useState('');
    const actividadId = props.eventoActual !== null ? props.eventoActual.actividad : null;

    const closeDialog = () => {
        editEvento(horas);
        setOpen(false);
        setHoras('')
    }

    return (
        <Dialog open={open} onClose={() => setOpen(false)}>
            <DialogTitle maxWidth='xs'>
                <Typography variant='h6'>Editar evento</Typography>
            </DialogTitle>
            <DialogContent>
                <Typography variant='body1'>Adicione la <b>nueva cantidad de {actividadId !== null && actividadId === 'ETN' ? ' encuestas ' : ' horas '}</b> de la actividad seleccionada.</Typography>
                <TextField
                    autoFocus={true}
                    style={{ marginTop: theme.spacing(2) }}
                    size='small'
                    variant='outlined'
                    label={`Nuevas ${actividadId !== null && actividadId === 'ETN' ? 'encuestas' : 'horas'}`}
                    fullWidth
                    value={horas}
                    onKeyPress={(e) => {
                        if (e.key === 'Enter')
                            closeDialog();
                    }}
                    onChange={(e) => {
                        if (actividadId !== null && actividadId === 'ETN') {
                            e.target.value = e.target.value.replace(/[^0-9]/g, '');
                            setHoras(e.target.value);
                        }
                        else {
                            var split = ''
                            if (e.target.value.includes('.')) {
                                split = e.target.value.split('.')
                                if (split[1].length < 2 && parseInt(split[0]) < 15) {
                                    e.target.value = split[0] + '.' + split[1].replace(/[^5]/g, '');
                                    setHoras(e.target.value);
                                }
                            }
                            else {
                                e.target.value = e.target.value.replace(/[^0-9.]/g, '');
                                if (e.target.value === '' || parseInt(e.target.value) <= 15) {
                                    setHoras(e.target.value);
                                }
                            }
                        }
                    }}
                />
            </DialogContent>
            <DialogActions>
                <Button color='primary' onClick={() => { setOpen(false); setHoras('') }} >
                    Cancelar
            </Button>
                <Button color='primary' onClick={() => closeDialog()}>
                    Aceptar
            </Button>
            </DialogActions>
        </Dialog>
    );
}

export default DialogoEditar;